module.exports = __webpack_public_path__ + "static/media/notification-banner-img.f38b777f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notification-banner-img.png
// module id = 1296
// module chunks = 1